import workspaceReducer from './workspace.reducer'

export * from './workspace.reducer'
export * from './workspace.selector'

export default workspaceReducer
